import(/* webpackMode: "eager" */ "/vercel/path0/src/app/login/[[...rest]]/page.tsx");
